module.exports = require("@swa-ui/itinerary/src/ItineraryBadge/ItineraryBadge.module.scss");